import axios from "axios";
import { BASE_CRM_API_URI } from "./constant";

const axiosInstance = axios.create({ baseURL: BASE_CRM_API_URI });

axiosInstance.interceptors.request.use(
  async (config) => {
    const authToken = localStorage.getItem("accessToken");
    if (authToken) {
      config.headers.Authorization = `Bearer ${authToken}`;
    }

    return config;
  },
  (error) => {
    if (error ?? error.message === "Queued for execution") {
      console.warn("Request queued due to ongoing request");
    } else {
      console.error(error);
    }
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  async (response) => {
    return response.data;
  },
  async (error) => {
    return Promise.reject(error);
  }
);

export const getApi = async (url, params) =>
  await axiosInstance.get(url, params);
export const postApi = async (url, req, params) =>
  await axiosInstance.post(url, req, params);
export const putApi = async (url, req, params) =>
  await axiosInstance.put(url, req, params);
export const deleteApi = async (url, req, params) =>
  await axiosInstance.delete(url, req, params);
export const patchApi = async (url, req, params) =>
  await axiosInstance.patch(url, req, params);

export function handleError(error) {
  if (error.message === "Queued for execution") {
    console.warn("Request queued due to ongoing request");
  } else {
    console.error(error);
  }
}
